import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const VideoHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on the top.
    <br/>
    <img src={makeToolTipUrl('video/1.CMS-video-headline.png')} width="100%"/>
  </div>
);

export const VideoIntroToolTip = (props) => (
  <div>
    Copy to introduce an overview of the break.
    <br/>
    <img src={makeToolTipUrl('video/2.CMS-video-intro.png')} width="100%"/>
  </div>
);

export const VideoEmbedCodeToolTip = (props) => (
  <div>
    HTML code that embeds the video.
  </div>
);

export const VideoIDToolTip = (props) => (
  <div>
    This is used to track video views in Wistia. It can be found by copying the last characters of the video URL. EX: https://campuslive.wistia.com/medias/<b>cgamnaew10</b>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/video-tool-tips.jsx